<template>
  <RouterLink :to="to">
    <li class="menu-item" :class="{ active }">
      <component :is="icon" class="icon" />
      <span class="label">{{ $t(label) }}</span>
    </li>
  </RouterLink>
</template>
<script lang="ts">
import { defineComponent } from "vue"
import type { Component, PropType } from "vue"
import { RouterLink, type RouteLocationRaw } from "vue-router"

export default defineComponent({
  name: "AsideMenuItem",
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: Object as () => Component,
      required: true,
    },
    to: {
      type: [String, Object] as PropType<RouteLocationRaw>,
      required: true,
    },
  },
  components: { RouterLink },
})
</script>
<style scoped lang="scss">
.menu-item {
  cursor: pointer;
  height: 60px;
  position: relative;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 12px;
  font-family: Montserrat;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.4px;
  text-align: center;

  &.active,
  &:hover {
    &::before,
    &::after {
      content: "";
      position: absolute;
      left: -32px;
      width: 4px;
      height: 43px;
      background: var(--gradient);
      border-radius: 8px;
      transform: matrix(0, 1, 1, 0, 0, 0) rotate(-90deg);
    }

    &::after {
      filter: blur(4px);
    }
  }

  &.active,
  &:hover {
    ::v-deep(svg) {
      path {
        fill: url(#gradient);
      }
    }
    .label {
      background: var(--text-gradient);
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}
</style>
